<template>
	<b-form
		ref="form"
		@submit.prevent="setComponentPost"
	>
		<b-form-group>
			<v-select
				v-model="component"
				label="Name"
				:options="equipment"
			/>
		</b-form-group>

		<b-button
			type="submit"
			variant="info"
		>Add Component</b-button>

	</b-form>
</template>

<script>
import VSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import EquipmentService from "@/api-services/equipment.service";

export default {
	name: "SetComponent",

	// things we want to use
	components: {
		VSelect
	},

	// things we have inherited from our parent
	props: [],

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function() {
		return {
			component: null,
			equipment: []
		};
	},

	created() {
		this.fetchEquipment();
	},

	// things we do to data
	methods: {
		setComponentPost() {
			this.$emit("add", this.component);
		},

		fetchEquipment(component) {
			EquipmentService.getAll().then(response => {
				this.equipment = response.data;
			});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/partials/set-component.vue